export default {"src":"/_next/static/media/settings.7bfcae04.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};